import { List, ResourceSectionCard } from '@all-manager/design-system-v2';
import { useGetOpenQuotes } from '../../api/useGetOpenQuotes';
import OpenQuoteItem from './OpenQuoteItem';

export default function OpenQuotesSection() {
  const { data: quotes, isLoading } = useGetOpenQuotes();

  const items = quotes ?? [];

  return (
    <ResourceSectionCard
      variant="documents"
      title="Devis en attente"
      count={items.length}
      isLoading={isLoading}
      isEmpty={items.length === 0}
      emptyLabel="Aucun devis en attente"
      data-testid="open-quotes-section"
    >
      <List disablePadding aria-label="Devis en attente de décision">
        {items.map((quote) => (
          <OpenQuoteItem key={quote.id} quote={quote} />
        ))}
      </List>
    </ResourceSectionCard>
  );
}
